import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import React from 'react'

interface PageCellProps {
  url: string
}

export const PageCell = ({ url }: PageCellProps) => {
  return (
    <div className='w-[300px] truncate'>
      <Tooltip title={url}>
        <BpAnchor href={url} target='_blank'>
          {url.replace(/^(http:\/\/|https:\/\/)?(www\.)?/, '')}
        </BpAnchor>
      </Tooltip>
    </div>
  )
}
